export enum StageCardStatus {
  SCHEDULED = 'SCHEDULED',
  SIGNED_OFF = 'SIGNED_OFF',
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  COMPLETED = 'COMPLETED',
}
